import styled from "styled-components";
import { styledByTheme } from "../../../../../themes/architecture/styled-by-theme";
import { DepositSideMenuLinkBox } from "./deposit-side-menu-link.box";

const SignupSideMenuLinkCasino888Box = styled(DepositSideMenuLinkBox)`
    font-size: 1.6rem;
    color: ${({theme}) => theme.colors.userMenuBalanceColor };
`;

export const SignupSideMenuLinkBox = styledByTheme(DepositSideMenuLinkBox)
    .forCasino888(SignupSideMenuLinkCasino888Box)
    .forDelawarePark(SignupSideMenuLinkCasino888Box)
    .forDoverDowns(SignupSideMenuLinkCasino888Box)
    .forHarrington(SignupSideMenuLinkCasino888Box)
    .apply();
